import StudentActionPanel from './student-action-panel'

export default StudentActionPanel
